const tabs = document.querySelectorAll('.tabs');

tabs.forEach(function(tab) {
	const tabButtons = tab.querySelectorAll('.tabs__button');

	tabButtons.forEach(function(button) {
		button.addEventListener('click', function(e) {
			e.preventDefault();
			const tabId = e.target.dataset.tab;
			const tabActive = tab.querySelector('.tabs__button.active');
			const tabContentActive = tab.querySelector('.tabs__tab.active');
			tabActive.classList.remove('active');
			tabContentActive.classList.remove('active');
			e.target.classList.add('active');
			tab.querySelector('#' + tabId).classList.add('active');
		});
	});

	if (tab.classList.contains('tab-adresses')) {
		let hash = window.location.hash;

		if (hash) {
			const tabActive = tab.querySelector('.tabs__button.active');
			const tabContentActive = tab.querySelector('.tabs__tab.active');
			tabActive.classList.remove('active');
			tabContentActive.classList.remove('active');
			tab.querySelector(hash).classList.add('active');
			hash = hash.replace('#', '');
			tab.querySelector('[data-tab="' + hash + '"]').classList.add('active');
		}

		tabButtons.forEach(function(button) {
			button.addEventListener('click', function(e) {
				const tabId = e.target.dataset.tab;
				history.pushState(null, null, '#' + tabId);
			});
		});
	}
});
